import type { HTMLAttributes, ReactNode } from "react";

/**
 * A white card on the page: 1px rule border, 0.75rem radius, no shadow (the
 * GMS surface). Content decides its own padding — a table runs edge to edge,
 * prose sits in `p-[1rem]`.
 */
export function Card({
	as: Tag = "section",
	className = "",
	children,
	...rest
}: HTMLAttributes<HTMLElement> & { as?: "section" | "div" | "article" | "aside"; children?: ReactNode }) {
	return (
		<Tag className={`min-w-0 rounded-card border border-rule bg-sheet ${className}`} {...rest}>
			{children}
		</Tag>
	);
}

/** A card's title row: the heading on the left, a link or button on the right, a rule under it. */
export function CardHeader({
	title,
	actions,
	subtitle,
	className = "",
	as: Heading = "h2",
}: {
	title: ReactNode;
	actions?: ReactNode;
	subtitle?: ReactNode;
	className?: string;
	as?: "h2" | "h3";
}) {
	return (
		<div className={`flex flex-wrap items-center justify-between gap-x-[0.75rem] gap-y-[0.25rem] border-rule border-b px-[1rem] py-[0.75rem] ${className}`}>
			<div className="flex min-w-0 flex-col">
				<Heading className="font-black text-[0.9375rem] text-ink leading-tight">{title}</Heading>
				{subtitle && <p className="text-[0.8125rem] text-muted">{subtitle}</p>}
			</div>
			{actions && <div className="flex items-center gap-[0.5rem] text-[0.875rem]">{actions}</div>}
		</div>
	);
}
